import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Segment,
  Button,
  Icon
} from 'semantic-ui-react'

const CardDrugClaimQAUX = (props: any) => {
    return(
      <div
        id="CardDrugClaimQAUX-div-0"
        style={{ width : "100%", height: "100%" }}>
        <Segment
          id="CardDrugClaimQAUX-Segment-1">
          <div
            id="CardDrugClaimQAUX-div-2"
            style={{display: "flex", justifyContent: "space-between"}}>
            
            <div
              id="CardDrugClaimQAUX-div-3"
              style={{fontWeight: "bold", fontSize: "1.2rem"}}>
              {props.title}
            </div>
            <div
              id="CardDrugClaimQAUX-div-12"
              style={{cursor: "pointer",...(props.hideClose && {display: "none"})}}>
              
              <Icon
                className="red"
                id="CardDrugClaimQAUX-Icon-14"
                name={"close"}
                onClick={props.onClose}>
              </Icon>
            </div>
          </div>
          <hr
            id="CardDrugClaimQAUX-hr-6">
          </hr>
          <div
            id="CardDrugClaimQAUX-div-7"
            style={{display: "flex", width: "100%", height: "100%"}}>
            
            <div
              id="CardDrugClaimQAUX-div-8"
              style={{cursor: "pointer", flex: 1, ...(props.disabledSubQATab && {display: "none"})}}>
              {props.subQATab}
            </div>
            <div
              id="CardDrugClaimQAUX-div-9"
              style={{marginLeft: "10px", flex: 2.5}}>
              {props.subQAField}
            </div>
          </div>
          <div
            id="CardDrugClaimQAUX-div-10"
            style={{display: "flex", justifyContent: "flex-end"}}>
            
            <Button
              color={"green"}
              disabled={props.statusRequest ? true : false}
              id="CardDrugClaimQAUX-Button-11"
              onClick={props.onSave}>
              {props.languageUX === "en" ? "Save" : "บันทึก"}
            </Button>
          </div>
        </Segment>
      </div>
    )
}


export default CardDrugClaimQAUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","language":"EN","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Fri Oct 31 2025 04:29:41 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugClaimQAUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width : \"100%\", height: \"100%\" }"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Segment",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugClaimQAUX-Segment-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugClaimQAUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": "props.title"
        },
        "id": {
          "type": "value",
          "value": "CardDrugClaimQAUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugClaimQAUX-hr-6"
        }
      },
      "seq": 6,
      "void": true
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugClaimQAUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", width: \"100%\", height: \"100%\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.subQATab"
        },
        "id": {
          "type": "value",
          "value": "CardDrugClaimQAUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\", flex: 1, ...(props.disabledSubQATab && {display: \"none\"})}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.subQAField"
        },
        "id": {
          "type": "value",
          "value": "CardDrugClaimQAUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\", flex: 2.5}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugClaimQAUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Button",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "Save"
        },
        "color": {
          "type": "code",
          "value": "\"green\""
        },
        "disabled": {
          "type": "code",
          "value": "props.statusRequest ? true : false"
        },
        "id": {
          "type": "value",
          "value": "CardDrugClaimQAUX-Button-11"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSave"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugClaimQAUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\",...(props.hideClose && {display: \"none\"})}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Icon",
      "parent": 12,
      "props": {
        "className": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardDrugClaimQAUX-Icon-14"
        },
        "name": {
          "type": "code",
          "value": "\"close\""
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 14,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 45,
  "isMounted": false,
  "memo": false,
  "name": "CardDrugClaimQAUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "language": "EN",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 60
}

*********************************************************************************** */
